'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Label;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _mergeProps = require('../../utils/mergeProps');

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _SpacerElement = require('../SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

var _Text = require('../Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'placeholder': 'ccl-12135172985687eb'
};

/**
 * Form label component.
 */

function Label(originalProps) {
  var isPlaceholder = originalProps.isPlaceholder;

  var props = isPlaceholder ? (0, _mergeProps2.default)(originalProps, Label.placeholderProps) : originalProps;
  var htmlFor = props.for,
      className = props.className,
      color = props.color,
      size = props.size,
      children = props.children,
      spacing = props.spacing,
      adjacentVerticalSpacing = props.adjacentVerticalSpacing,
      adjacentHorizontalSpacing = props.adjacentHorizontalSpacing;


  return _react2.default.createElement(
    _Text2.default,
    {
      color: color,
      size: size,
      element: 'label',
      spacing: spacing,
      adjacentVerticalSpacing: adjacentVerticalSpacing,
      adjacentHorizontalSpacing: adjacentHorizontalSpacing,
      className: (0, _classnames3.default)(styles.label, className),
      additionalProps: { htmlFor: htmlFor },
      isPlaceholder: isPlaceholder,
      placeholderClassName: (0, _classnames3.default)(_defineProperty({}, styles.placeholder, isPlaceholder)),
      isBlock: true
    },
    children
  );
}

Label.displayName = 'Label';
Label.propTypes = _extends({
  /**
   * The id attribute of the field this label is associated with.
   * Optional if the Label instance wraps the input element.
   */
  for: _propTypes2.default.string,

  className: _propTypes2.default.string,

  /**
   * Child nodes (e.g. the text of the label).
   */
  children: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.node, function (props) {
    return !props.isPlaceholder;
  }),

  color: _Text2.default.propTypes.color,
  size: _Text2.default.propTypes.size
}, _SpacerElement2.default.propTypes);

Label.defaultProps = _extends({
  for: undefined,
  color: 'grey',
  size: 'small'
}, _SpacerElement2.default.defaultProps);

Label.placeholderProps = {
  children: 'placeholder'
};